<template>
  <VBtn icon="mdi-close" rounded="0" elevation="0" density="comfortable" border />
</template>
